import React from 'react';

import {Helmet} from 'views/module';

import ClientMetricsScene from 'views/scenes/metrics/client_metrics/ClientMetrics';

const ClientMetricsPage = () => {
  return (
    <>
      <Helmet>
        <title>Quilt: Client Metrics</title>
      </Helmet>
      <ClientMetricsScene />
    </>
  );
};

export default ClientMetricsPage;
